/**
 * The **Cookie Bar** implementation is supposed to be injected by Google Tag
 * Manager.
 *
 * @module
 */
import {window} from '@acng/frontend-bounty/dom/window.js';
import {isFunction} from '@acng/frontend-bounty/std/value.js';
import {NamespaceController, ClickEventController} from 'nova';

/**
 * @example
 *
 * ```html
 * <!--@ ${settings.cookie} -->
 * <section>
 *   <!--@ ${click} -->
 *   <button>Show the cookie bar</button>
 * </section>
 * ```
 */
class CookieBar extends NamespaceController {
  /**
   * Show the cookie bar.
   *
   * @type {(() => void) | undefined}
   */
  // @ts-ignore Definitely not typed.
  #showCookieBar = window.CookieScript?.instance?.show;

  /**
   * @example
   *
   * ```html
   * <!--@ ${ok} -->
   * <strong>The cookie bar is available.</strong>
   * ```
   */
  ok = isFunction(this.#showCookieBar);

  /**
   * @example
   *
   * ```html
   * <!--@ ${error} -->
   * <strong>The cookie bar is <em>not</em> available.</strong>
   * ```
   */
  error = !this.ok;

  /**
   * @example
   *
   * ```html
   * <!--@ ${click} -->
   * <button>Show the cookie bar</button>
   * ```
   */
  click = this.#showCookieBar ? new ClickEventController(this.#showCookieBar) : null;
}

export {CookieBar};
